export default "__VITE_ASSET__DKsEOHM7__"